<template>
  <div
    :class="sidebarClasses"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <center>
        <img :src="title" alt style="width: 70%" />
      </center>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <ul :class="navClasses">
        <slot name="links">
          <!-- administrador -->
          <!-- dashboard -->
          <sidebar-item :link="{name: 'Dashboard', icon: 'fa fa-home'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Dashboard'"
            >

            </sidebar-item >
            <sidebar-item  :link="{name: 'Mi Espacio', 
            path: '/mi-espacio',
            icon: 'ti-file'
            }"
            v-if="rol==2 || rol==3 || rol==4 || rol==5 || rol==6">

            </sidebar-item>
          </sidebar-item>
          <!-- reportes -->
          <sidebar-item :link="{name: 'Reportes', icon: 'fa fa-folder'}">
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Reportes'"
            >

            </sidebar-item>
          <!-- <sidebar-item v-if="rol==1"
          :link="{
            name: 'Reporte programación', 
            icon: 'ti-file',
            path: '/reportes/programacion'}"> 

          </sidebar-item> -->
          </sidebar-item>
          <!-- Admisiones -->

           <sidebar-item :link="{name: 'Admisiones', icon: 'fa fa-user'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Admisiones'"
            >

            </sidebar-item>
            <!-- historia clinica -->
          </sidebar-item>

           <sidebar-item :link="{name: 'Historia Clínica', icon: 'fa fa-folder'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Historia Clinica'"
            >

            </sidebar-item>
            <!-- Mantenimiento -->
          </sidebar-item>

          <sidebar-item :link="{name: 'Mantenimiento', icon: 'fa fa-gear'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Mantenimiento'"
            >

            </sidebar-item>
          </sidebar-item>
          <!-- acceso -->

          <sidebar-item :link="{name: 'Acceso', icon: 'fa fa-key'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Acceso'"
            >

            </sidebar-item>
          </sidebar-item>

          <!-- Plan de intervención -->

           <sidebar-item :link="{name: 'Plan de intervención', icon: 'fa fa-book'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Plan de intervención'"
            >

            </sidebar-item>
          </sidebar-item>

          <!-- Programacion -->

           <sidebar-item :link="{name: 'Programación', icon: 'fa fa-calendar'}" >
            <sidebar-item v-for="permiso in permisos" :key="permiso.id"
            :link="{
              name: permiso.name,
              icon: permiso.icon,
              path: permiso.path
            }"
            v-if="permiso.modulo == 'Programación'"
            >

            </sidebar-item>
          </sidebar-item>

          

          <!-- <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
            v-if="rol == 1"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item> -->
          <!-- administrador fin -->
          <!-- terapeutas -->
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import SidebarItem from './SidebarItem.vue';

export default {
  components: { SidebarItem },
  props: {
    title: {
      type: String,
      default: "/static/img/logo.webp",
    },
    type: {
      type: String,
      default: "sidebar",
      validator: (value) => {
        let acceptedValues = ["sidebar", "navbar"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      // default: 'static/img/logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    sidebarClasses() {
      if (this.type === "sidebar") {
        return "sidebar";
      } else {
        return "collapse navbar-collapse off-canvas-sidebar";
      }
    },
    navClasses() {
      if (this.type === "sidebar") {
        return "nav";
      } else {
        return "nav navbar-nav";
      }
    },
  },
  methods: {
    async initScrollBarAsync() {
      await import("perfect-scrollbar/dist/css/perfect-scrollbar.css");
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },

    getPermisos() {
      const BASE_URL = `${this.ip}permisos/${localStorage.getItem("rol")}`;
      if (!localStorage.getItem("rol")) {
        this.$router.push("/");
      } else {
        axios
          .get(BASE_URL)
          .then((res) => {
            // console.log(res.data);
            this.permisos = res.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  data() {
    return {
      rol: localStorage.getItem("rol"),
      permisos: [],
      ip: "https://avanti-erp.com/api/",
    };
  },
  mounted() {
    this.initScrollBarAsync();
    this.getPermisos();
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue